const src = import.meta.ROLLUP_FILE_URL_nJkgIVJgL11RgZiGUBj6wA;
export default {
  src,
  srcSet: src + " " + 1590 + "w",
  width: 1590,
  height: 884,
};